export default __webpack_public_path__ + "static/media/texture.da3a0b060bd9f921fcad65d661cdc03c.png";